import React, { useState, useEffect, useContext } from 'react';



import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { isAuxFormatter, natureFormatter } from '../../components/formatters/defFormatter';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { Space, Input, Tag, Button, Tabs, Checkbox } from 'antd';
import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';


import Select from 'react-select';
import AsyncSelect from 'react-select/async';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';
import { DynamicModalContext } from '../../init/dynamicModals';




function CustomerForm(props) {

  let { showModal, toggleModal, idRow, refreshTable, refAddedData } = props;


  const { userData, settingData, refData, api, accountGroupData, accountTypeData, companyId, formLanguages } = useContext(DataContext);
  const { setAddedCustomer } = useContext(DynamicModalContext);


  const userRole = userData.role;
  const createdBy = parseInt(userData.id);

  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [validated, setValidated] = useState(false);




  const today = new Date().toISOString().split('T')[0];


  const [account, setAccount] = useState([]);


  useEffect(() => {
    if (showModal) {
      fetchData();
    } else {
      setIsLoading(true);
    }
  }, [showModal]);


  const fetchData = async () => {
    try {
      const dataArray = ['accountGroup']
      await refData(dataArray, companyId);
      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };

  const refAddedAccountData = async (res) => {
    try {
      let dataArray = ['customerAccount', 'auxAccount']
      refData(dataArray, companyId);

      closeModal();
      if (setAddedCustomer) {
        setAddedCustomer(res.data.account);
      }
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setAccount((prev) => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : null,
    }));

  };


  // Group Options
  const groupOptions = accountGroupData?.map(item => ({
    value: item.id,
    label: `${item.name}`,
  }));


  // idRow Change
  useEffect(() => {
    setAccount(
      {
        english: idRow?.english || '',
        phone: idRow?.phone || '',
        registration: idRow?.registration || '',
        address: idRow?.address || '',
        details: idRow?.details || '',

        parentId: settingData?.customerAccountId,
        groupId: idRow?.groupId || null,
        type: 'Customer',
        isDebit: true,

        isActive: idRow?.isActive == false ? false : true,
        isAux: true,
        createdBy: createdBy,
        companyId: companyId,
      }
    )
  }, [idRow, toggleModal]);


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setAccount((prev) => ({
      ...prev,
      [name]: value,
    }));
  };




  const onCheckChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    setAccount((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = document.getElementById('customerForm');

    if (form.checkValidity() === false) {
      return;
    }

    setLoadingEffect(true);

    const data = {
      account,
      id: idRow?.id,
    }

    const operation = idRow ? 'edit' : 'add '
    try {
      let res = await api.post(`account/${operation}`, data);

      if (res.data.status) {
        toast.success(res.data.message);
        if (refAddedData) {
          refAddedAccountData(res);
        } else {
          closeModal();
        }
      } else {
        toast.error(res.data.message);
        setLoadingEffect(false);
        setValidated(false);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
      console.log(error)
    }
  }

  const closeModal = () => {
    toggleModal();
    setLoadingEffect(false);
    setValidated(false);
    const form = document.getElementById('form');
    if (form) { form.reset() };
    if (refreshTable) { refreshTable() };
  }


  return (
    <div>

      <Modal show={showModal} size={'lg'} onHide={toggleModal} backdrop="static">

        <Modal.Header style={{ background: "#23576a" }} closeButton>
          <Modal.Title style={{ color: "white" }}>{idRow ? formLanguages?.Edit : formLanguages.Add} {formLanguages?.Customer}</Modal.Title>
        </Modal.Header>


        {isLoading &&
          <div style={{ height: '20vh' }}>
            <Loader />
          </div>
        }

        {!isLoading &&

          <Form validated={validated} id={'customerForm'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >

            <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f9fafa' }}>

              <Row className="mb-3">

                {/* Name  */}
                <Col>
                  <Form.Label>{formLanguages.Name}<span style={{ color: 'red' }}> *</span></Form.Label>
                  <Form.Control type="text" name='english'
                    value={account.english}
                    onChange={handleInputChange}
                    required
                  />
                </Col>

                {/* Registration  */}
                <Col>
                  <Form.Label>{formLanguages.Registration} #</Form.Label>
                  <Form.Control type="text" name='registration'
                    value={account.registration}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>


              <Row className="mb-3">


                {/* Name  */}
                <Col>
                  <Form.Label>{formLanguages.Phone}</Form.Label>
                  <Form.Control type="text" name='phone'
                    value={account.phone}
                    onChange={handleInputChange}
                  />
                </Col>



                <Col>
                  <Form.Label>{formLanguages.Group}</Form.Label>
                  <Select
                    options={groupOptions}
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Select"
                    onChange={(e) => handleSelectChange(e, 'groupId')}
                    value={groupOptions?.find(option => option.value === account.groupId) || []}
                  />
                </Col>
              </Row>



              <Row className="mb-3">
                {/* Address  */}
                <Col>
                  <Form.Label>{formLanguages.Address}</Form.Label>
                  <Form.Control as="textarea" name="address" value={account.address}
                    onChange={handleInputChange}
                  />
                </Col>
                {/* Details  */}
                <Col>
                  <Form.Label>{formLanguages.Details}</Form.Label>
                  <Form.Control as="textarea" name="details" value={account.details}
                    onChange={handleInputChange}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Checkbox onChange={onCheckChange} checked={account.isActive} name="isActive">
                    isActive
                  </Checkbox>
                </Col>
              </Row>



            </Modal.Body>


            <Modal.Footer>
              <Button type="primary" loading={loadingEffect} htmlType="submit"
                onClick={() => setValidated(true)}
                style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
            </Modal.Footer>

          </Form>
        }




      </Modal >


    </div >
  )
}

export default CustomerForm;
